/* global axios */

// Helper to get accountId from current URL since we are proxying via Chatwoot backend
function getAccountId() {
  const isInsideAccountScopedURLs = window.location.pathname.includes('/app/accounts');
  if (isInsideAccountScopedURLs) {
    return window.location.pathname.split('/')[3];
  }
  return '';
}

function getBaseUrl() {
  const accountId = getAccountId();
  return `/api/v1/accounts/${accountId}/badwords`;
}

export default {
  // Authentication is now handled by the backend
  authenticateIfNeeded() {
    return Promise.resolve();
  },

  getAll(params = {}) {
    return axios.get(getBaseUrl(), { params });
  },

  create(data) {
    return axios.post(getBaseUrl(), data);
  },

  update(id, data) {
    // Controller can handle both PUT and PATCH
    return axios.put(`${getBaseUrl()}/${id}`, data);
  },

  delete(id) {
    return axios.delete(`${getBaseUrl()}/${id}`);
  },
};
